const SUPPORTED_CURRENCIES = ['EUR', 'USD', 'MXN'] as const

export type CurrencyFormat = (typeof SUPPORTED_CURRENCIES)[number]

export function currencyFormatters(
  currency: CurrencyFormat,
  milis = false,
  rounded = false
): Intl.NumberFormat {
  const maxFractionDigits = milis ? 3 : 2
  const config = {
    style: 'currency',
    currency: currency ?? 'EUR',
    maximumFractionDigits: maxFractionDigits,
    minimumFractionDigits: rounded ? 0 : maxFractionDigits
  } as const
  const formats = {
    EUR: 'es-ES',
    USD: 'en-EN',
    GBP: 'en-EN',
    MXN: 'es-MX'
  } as const
  return new Intl.NumberFormat(formats[currency], config)
}

export function currencyFilter(
  value: number,
  currency: CurrencyFormat = 'EUR',
  milis = false,
  rounded = false
): string {
  const decimalValue = milis ? value / 1000 : value / 100
  if (!SUPPORTED_CURRENCIES.includes(currency)) {
    return currencyFormatters('EUR', milis, rounded).format(decimalValue)
  }
  return currencyFormatters(currency, milis, rounded).format(decimalValue)
}

export function currencySymbol(currency: CurrencyFormat = 'EUR'): string {
  return currencyFilter(0, currency)
    .replace(/\d|[,.]/g, '')
    .trim()
}

export function getCurrencyIcon(currencyCode: string) {
  switch (currencyCode) {
    case 'MXN':
      return 'currency'
    case 'EUR':
      return 'euro'
    case 'USD':
      return 'currency'
    default:
      return 'euro'
  }
}

export function toMajorCurrency(value: number): number {
  return (value / 100).toFixed(2) as unknown as number
}

export function defaultCurrencyByCountry(countryCode: string): CurrencyFormat {
  switch (countryCode) {
    case 'ES':
    case 'DE':
      return 'EUR'
    case 'MX':
      return 'MXN'
    default:
      return 'EUR'
  }
}
